import { render, staticRenderFns } from "./bulma_tableprops.vue?vue&type=template&id=09d172b6&scoped=true"
import script from "./bulma_tableprops.vue?vue&type=script&lang=js"
export * from "./bulma_tableprops.vue?vue&type=script&lang=js"
import style0 from "./bulma_tableprops.vue?vue&type=style&index=0&id=09d172b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d172b6",
  null
  
)

export default component.exports